import { render, staticRenderFns } from "./payLayer.vue?vue&type=template&id=8c08a8ee&scoped=true&"
import script from "./payLayer.vue?vue&type=script&lang=js&"
export * from "./payLayer.vue?vue&type=script&lang=js&"
import style0 from "./payLayer.vue?vue&type=style&index=0&id=8c08a8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c08a8ee",
  null
  
)

export default component.exports